import React from 'react'
import { useTranslation } from 'react-i18next'
import { appLocale, LOCALE_STORAGE_KEY } from '@/i18n'

interface LocaleSwitcherProps {
  // 'auth' = white text on dark bg (login page)
  // 'sidebar' = inherits --color-sidebar-text via opacity (app sidebar)
  variant?: 'auth' | 'sidebar'
}

// Rendered whenever the tenant locale is not English. Shows e.g. "JA | EN"
// and lets the user toggle between the tenant language and English.
// Preference persists in localStorage.
const LocaleSwitcher: React.FC<LocaleSwitcherProps> = ({ variant = 'auth' }) => {
  const { i18n } = useTranslation()

  if (appLocale === 'en') return null

  const isEn = i18n.language === 'en'

  const toggle = () => {
    const next = isEn ? appLocale : 'en'
    localStorage.setItem(LOCALE_STORAGE_KEY, next)
    i18n.changeLanguage(next)
  }

  const baseClass =
    variant === 'sidebar'
      ? 'flex items-center gap-1 text-xs font-medium opacity-70 hover:opacity-100 transition-opacity select-none'
      : 'flex items-center gap-1 text-sm font-medium text-white/80 hover:text-white transition-colors select-none'

  return (
    <button
      type="button"
      onClick={toggle}
      className={baseClass}
      aria-label="Switch language"
    >
      <span className={!isEn ? 'opacity-100 font-semibold' : 'opacity-50'}>
        {appLocale.toUpperCase()}
      </span>
      <span className="opacity-40 mx-0.5">|</span>
      <span className={isEn ? 'opacity-100 font-semibold' : 'opacity-50'}>EN</span>
    </button>
  )
}

export default LocaleSwitcher
